module.exports = __webpack_public_path__ + "img/xidada5.4bb36871.png";